import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { STATUS_KEYS, STATUS_META } from "@/components/territory/statusMeta";

/** The four quadrants, clickable as a filter. Counts come straight from the backend. */
export const StatusMatrix = ({ totals = {}, active = "", onSelect, windowDays = 90 }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="status-matrix">
    {STATUS_KEYS.map((key) => {
      const meta = STATUS_META[key];
      const count = totals[key] ?? 0;
      const share = totals.total ? Math.round((count / totals.total) * 100) : 0;
      return (
        <Card
          key={key}
          onClick={() => onSelect?.(active === key ? "" : key)}
          className={`cursor-pointer border-l-4 ${meta.accent} transition-[box-shadow,border-color] hover:shadow-md ${
            active === key ? "ring-2 ring-blue-400" : ""
          }`}
          data-testid={`status-card-${key}`}
        >
          <CardContent className="p-3">
            <p className="text-xs text-muted-foreground flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: meta.dot }} />
              {meta.label}
            </p>
            <p className={`text-2xl font-bold ${meta.text}`}>{count}</p>
            <p className="text-[11px] text-muted-foreground">{share}% of territory</p>
          </CardContent>
        </Card>
      );
    })}
    <Card
      onClick={() => onSelect?.("")}
      className={`cursor-pointer border-l-4 border-l-slate-400 hover:shadow-md ${
        active ? "" : "ring-2 ring-blue-400"
      }`}
      data-testid="status-card-all"
    >
      <CardContent className="p-3">
        <p className="text-xs text-muted-foreground">All doctors</p>
        <p className="text-2xl font-bold">{totals.total ?? 0}</p>
        <p className="text-[11px] text-muted-foreground">last {windowDays} days</p>
      </CardContent>
    </Card>
  </div>
);

export default StatusMatrix;
